import {Map, Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

class AsyncButtonRecord extends Record<{
    readonly loading: boolean;
    readonly percentage?: number;
    readonly generationId?: string;
    readonly url?: string;
    readonly linkArgs?: {[key: string]: string};
}>({
    loading: false,
    percentage: undefined,
    generationId: undefined,
    url: undefined,
    linkArgs: undefined,
}) {}

export type AsyncButtonState = Map<string, AsyncButtonRecord>;

export default makeReducer<AsyncButtonState>(
    [
        match(Actions.generateAsyncLink, (state, {payload}) => {
            return state.set(
                payload.identifier,
                new AsyncButtonRecord({
                    linkArgs: payload.args,
                    loading: true,
                }),
            );
        }),
        match(Actions.generateAsyncLinkGQL, (state, {payload}) => {
            return state.set(
                payload.identifier,
                new AsyncButtonRecord({
                    linkArgs: payload.args,
                    loading: true,
                }),
            );
        }),
        match(Actions.generateAsyncLinkSuccess, (state, {payload}) => {
            return state.update(payload.identifier, buttonState =>
                buttonState.merge({
                    loading: false,
                    url: payload.url,
                }),
            );
        }),
        match(Actions.generateAsyncLinkUpdate, (state, {payload}) => {
            return state.update(payload.identifier, buttonState =>
                buttonState.merge({
                    percentage: payload.percentage,
                }),
            );
        }),
        match(Actions.generateAsyncLinkFailed, (state, {payload}) => {
            return state.delete(payload.identifier);
        }),
        match(Actions.setAsyncLinkGenerationId, (state, {payload}) => {
            return state.update(payload.identifier, buttonState =>
                buttonState.merge({generationId: payload.generationId}),
            );
        }),
    ],
    Map(),
);
